import React from 'react'
import {AppTable,AppFilter} from 'qcc'

export interface IAppGridLayoutContext {
	refTable?:AppTable;
	setRefTable?:(refTable?:AppTable)=>void
	onSearch?:(filterList?:AppFilter[],data?:any)=>void
}
export const AppGridLayoutContext = React.createContext<IAppGridLayoutContext>({} as IAppGridLayoutContext)



// WEBPACK FOOTER //
// ./src/qcc/AppGridLayout/AppGridLayoutContext.tsx